export const useTokenChecker = () => {
  window.addEventListener('storage', () => {
    if (!localStorage.getItem('token')) {
      window.location.replace('/login');
    }
  });
};
